<div class="delivery-container mat-elevation-z2">
  <!-- Header & Filters -->
  <div class="table-header">
    <div class="header-top">
      <h2>Delivery Orders</h2>
      <div class="header-actions">
        <button mat-flat-button color="primary" (click)="openCreateDialog()">Add Delivery</button>
        <button mat-stroked-button color="accent" (click)="resetFilters()">Reset Filters</button>
      </div>
    </div>

    <div class="filter-section">
      <mat-form-field appearance="outline">
        <mat-label>From</mat-label>
        <input matInput type="date" [(ngModel)]="filter.from" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>To</mat-label>
        <input matInput type="date" [(ngModel)]="filter.to" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Payment</mat-label>
        <mat-select [(ngModel)]="filter.isPaid">
          <mat-option value="">All</mat-option>
          <mat-option value="true">Paid</mat-option>
          <mat-option value="false">Unpaid</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <input
          matInput
          (keyup)="applySearch($event)"
          placeholder="Search by name, driver, or reference..."
        />
      </mat-form-field>

      <button mat-flat-button color="accent" (click)="applyFilters()">Apply</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="!loading && dataSource?.data?.length === 0" class="empty-state">
    <p>No delivery orders found.</p>
  </div>

  <div class="table-scroll-wrapper" *ngIf="dataSource?.data?.length">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 full-width-table">

      <!-- Customer -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
        <td mat-cell *matCellDef="let o">{{ o.customerName }}</td>
      </ng-container>

      <ng-container matColumnDef="contactNumber">
        <th mat-header-cell *matHeaderCellDef>Contact</th>
        <td mat-cell *matCellDef="let o">{{ o.contactNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="driverName">
        <th mat-header-cell *matHeaderCellDef>Driver</th>
        <td mat-cell *matCellDef="let o">{{ o.driverName }}</td>
      </ng-container>

      <ng-container matColumnDef="vehicleNumber">
        <th mat-header-cell *matHeaderCellDef>Vehicle</th>
        <td mat-cell *matCellDef="let o">{{ o.vehicleNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="pickupLocation">
        <th mat-header-cell *matHeaderCellDef>Pickup</th>
        <td mat-cell *matCellDef="let o">{{ o.pickupLocation }}</td>
      </ng-container>

      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef>Item</th>
        <td mat-cell *matCellDef="let o">{{ o.item || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="deliveryLocation">
        <th mat-header-cell *matHeaderCellDef>Delivery</th>
        <td mat-cell *matCellDef="let o">{{ o.deliveryLocation }}</td>
      </ng-container>

      <ng-container matColumnDef="receiverContact">
        <th mat-header-cell *matHeaderCellDef>Receiver Contact</th>
        <td mat-cell *matCellDef="let o">{{ o.receiverContact || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>Notes</th>
        <td mat-cell *matCellDef="let o">{{ o.notes || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let o">₦{{ o.amount | number }}</td>
      </ng-container>

      <ng-container matColumnDef="isPaid">
        <th mat-header-cell *matHeaderCellDef>Paid</th>
        <td mat-cell *matCellDef="let o">
          <span [ngClass]="o.isPaid ? 'paid' : 'unpaid'">{{ o.isPaid ? 'Yes' : 'No' }}</span>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="isCancelled">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let o">
          <span [ngClass]="{
              'cancelled': o.isCancelled,
              'active': !o.isCancelled
            }">
            {{ o.isCancelled ? 'Cancelled' : 'Active' }}
          </span>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let o">
          <span
            class="status"
            [ngClass]="{
              'done': o.isPaid,
              'cancelled': o.isCancelled,
              'pending': !o.isPaid && !o.isCancelled
            }"
          >
            <mat-icon *ngIf="o.isPaid">check_circle</mat-icon>
            <mat-icon *ngIf="o.isCancelled">cancel</mat-icon>
            <mat-icon *ngIf="!o.isPaid && !o.isCancelled">hourglass_empty</mat-icon>
      
            {{ o.isPaid ? 'Done' : o.isCancelled ? 'Cancelled' : 'Pending' }}
          </span>
        </td>
      </ng-container>
      

      <ng-container matColumnDef="paymentReference">
        <th mat-header-cell *matHeaderCellDef>Reference</th>
        <td mat-cell *matCellDef="let o">{{ o.paymentReference || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="orderDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let o">{{ o.orderDate | date: 'short' }}</td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let o">
          <div class="action-buttons">
      
            <!-- ✅ Show icons only if not paid or cancelled -->
            <ng-container *ngIf="!o.isPaid && !o.isCancelled; else statusBlock">
      
              <!-- Mark as Paid -->
              <button
                mat-icon-button
                color="primary"
                (click)="markAsPaid(o)"
                matTooltip="Mark as Paid"
              >
                <mat-icon>check_circle</mat-icon>
              </button>
      
              <!-- Cancel Order -->
              <button
                mat-icon-button
                color="warn"
                (click)="cancelOrder(o)"
                matTooltip="Cancel Order"
              >
                <mat-icon>cancel</mat-icon>
              </button>
      
            </ng-container>
      
            <!-- ✅ Status Display -->
            <ng-template #statusBlock>
              <mat-icon
                *ngIf="o.isPaid"
                color="primary"
                matTooltip="Done"
              >
                check_circle
              </mat-icon>
      
              <mat-icon
                *ngIf="o.isCancelled"
                color="warn"
                matTooltip="Cancelled"
              >
                cancel
              </mat-icon>
            </ng-template>
          </div>
        </td>
      </ng-container>
      
      
      

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
